// src/module/util/index.ts
function generateUUIDv4() {
  return ("10000000-1000-4000-8000" + -1e11).replace(
    /[018]/g,
    (c) => (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
  );
}
function isValidSalesforceId(str) {
  if (typeof str !== "string" || str.length !== 18) {
    return false;
  }
  const upperCaseToBit = (char) => char.match(/[A-Z]/) ? "1" : "0";
  const binaryToSymbol = (digit) => digit <= 25 ? String.fromCharCode(digit + 65) : String.fromCharCode(digit - 26 + 48);
  const parts = [
    str.slice(0, 5).split("").reverse().map(upperCaseToBit).join(""),
    str.slice(5, 10).split("").reverse().map(upperCaseToBit).join(""),
    str.slice(10, 15).split("").reverse().map(upperCaseToBit).join("")
  ];
  const check = parts.map((str2) => binaryToSymbol(Number.parseInt(str2, 2))).join("");
  return check === str.slice(-3);
}
function arraysEqual(a, b, ignoreOrder = false) {
  if (a === b) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }
  const _a = ignoreOrder ? [...a].sort() : a;
  const _b = ignoreOrder ? [...b].sort() : b;
  for (let i = 0; i < _a.length; ++i) {
    if (_a[i] !== _b[i]) {
      return false;
    }
  }
  return true;
}

export { arraysEqual, generateUUIDv4, isValidSalesforceId };
